/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */

import React from 'react';

import Discuss from 'parts/Discuss';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { Fade } from "react-awesome-reveal";
import Button from 'elements/Button';

// Replace with your real estate image

export default function RealEstateAndPropertyManagement() {
  return (
    <>
      {/* CHALLENGES SECTION */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl lg:text-4xl text-theme-blue font-extrabold text-center mb-6">Challenges in Real Estate & Property Management</h2>
          <p className="text-center text-gray-600 mb-10">
            Property management and real estate operations rely heavily on communication, secure data, and reliable systems.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

            <div className="p-6 bg-white rounded-2xl shadow-md">
              <h3 className="text-xl font-semibold text-theme-blue mb-2">Tenant & Client Communication</h3>
              <p className="text-gray-600">Modern communication tools are essential for timely responses and tenant satisfaction.</p>
            </div>

            <div className="p-6 bg-white rounded-2xl shadow-md">
              <h3 className="text-xl font-semibold text-theme-blue mb-2">Document & Contract Management</h3>
              <p className="text-gray-600">Digital systems help securely store, share, and manage paperwork and legal contracts.</p>
            </div>

            <div className="p-6 bg-white rounded-2xl shadow-md">
              <h3 className="text-xl font-semibold text-theme-blue mb-2">Security & Access Control</h3>
              <p className="text-gray-600">Ensuring property, data, and tenant information remain protected with modern security solutions.</p>
            </div>

          </div>
        </div>
      </section>

      {/* BENEFITS SECTION */}
      <section className="py-16">
        <div className="container mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

          <div>
            <h2 className="text-3xl lg:text-4xl text-theme-blue font-extrabold mb-4">How We Support Real Estate & Property Management</h2>
            <ul className="space-y-6 text-gray-600">

              <li className="flex items-start gap-4">
<Fade triggerOnce delay={20}>
                  <span className="text-2xl leading-none"> <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#47d14a" }} /> </span></Fade>
                <div>
                  <p className="font-semibold">Improved Tenant Experience</p>
                  <p className="text-sm">Reliable communication channels and digital tools that keep tenants informed and satisfied.</p>
                </div>
              </li>

              <li className="flex items-start gap-4">
<Fade triggerOnce delay={20}>
                  <span className="text-2xl leading-none"> <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#47d14a" }} /> </span></Fade>
                <div>
                  <p className="font-semibold">Better Workflow Efficiency</p>
                  <p className="text-sm">Automation and cloud platforms that simplify tasks like billing, scheduling, and maintenance.</p>
                </div>
              </li>

              <li className="flex items-start gap-4">
<Fade triggerOnce delay={20}>
                  <span className="text-2xl leading-none"> <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#47d14a" }} /> </span></Fade>
                <div>
                  <p className="font-semibold">Secure Access & Data Protection</p>
                  <p className="text-sm">Modern cybersecurity infrastructure to protect tenants, staff, and sensitive property records.</p>
                </div>
              </li>

            </ul>

            <div className="mt-6">
              <Button href="/contact" type="link" className="px-6 py-3 bg-theme-purple text-white rounded-full hover:bg-dark-theme-purple transition duration-200">Request an IT Assessment</Button>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-md p-6">
            <h3 className="text-xl font-semibold text-theme-blue mb-4">Typical Outcomes</h3>
            <div className="space-y-4 text-gray-600">
              <p> <FontAwesomeIcon icon={faCircleCheck}  size="lg" style={{ color: "#47d14a" }} /> <strong>Happier tenants & clients</strong></p>
              <p> <FontAwesomeIcon icon={faCircleCheck}  size="lg" style={{ color: "#47d14a" }} /> <strong>More secure digital operations</strong></p>
              <p> <FontAwesomeIcon icon={faCircleCheck}  size="lg" style={{ color: "#47d14a" }} /> <strong>Better-organized workflows</strong></p>
              <p> <FontAwesomeIcon icon={faCircleCheck}  size="lg" style={{ color: "#47d14a" }} /> <strong>Reduced operational downtime</strong></p>
            </div>
          </div>

        </div>
      </section>

      {/* CTA SECTION */}
      <section className="py-16 bg-gradient-to-r from-light-theme-purple to-white">
        <div className="container mx-auto px-6 flex flex-col lg:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="text-2xl lg:text-3xl text-theme-blue font-bold">Want to modernize your property management systems?</h2>
            <p className="text-gray-600 mt-2">We help real estate organizations upgrade their IT infrastructure for smoother operations and better results.</p>
          </div>

          <div>
            <Button href="/contact" type="link" className="px-6 py-3 bg-theme-purple text-white rounded-full hover:bg-dark-theme-purple transition duration-200">Start Now</Button>
          </div>
        </div>
      </section>

      <Discuss />
    </>
  );
}
